// Typelizer digest a827353b55e951e4dd73ec5b96a4ca7f
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET / */
  home: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/', {}, options),
    method: 'get',
  }),

  /** GET /about */
  about: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/about', {}, options),
    method: 'get',
  }),
}
